import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { Chart } from "react-chartjs-2";
import PropTypes from "prop-types";
import PieChartLegend from "./PieChartLegend";
import { Chart as ChartJS, ArcElement, Legend, Tooltip, PieController } from "chart.js";
ChartJS.register(ArcElement, Legend, Tooltip, PieController);
const randomColor = require('randomcolor');
function PieChart({ data, groupBy }) {
    const chartLabels = data.map((item) => {
        return groupBy === 'toolName' ? item[groupBy] : `${item[groupBy]} - ${item.media}`;
    });
    const total = data.reduce((previousValue, item) => previousValue + item.spend, 0);
    const percentage = data.map((item) => Math.round((item.spend / total) * 100));
    const costLabel = data.map((item) => item.spend);
    const mediaLabel = data.map((item) => (item.medias || []).length);
    const chartColors = randomColor({ count: chartLabels.length, luminosity: "bright", format: "rgb" });
    let options = {
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                usePointStyle: true,
                padding: 16,
                boxWidth: 8,
                boxHeight: 8,
                boxPadding: 5,
                backgroundColor: "#172B4D",
                footerFont: {
                    size: 12,
                    weight: '400',
                    lineHeight: 1.5,
                },
                callbacks: {
                    labelPointStyle: function (context) {
                        return {
                            pointStyle: "circle",
                            rotation: 0,
                        };
                    },
                    label: function (context) {
                        let label = context.label;
                        return label;
                    },
                    beforeFooter: function (context) {
                        let percent = "Percentage: " + context[0].formattedValue + "%";
                        return percent;
                    },
                    afterFooter: function (context) {
                        let price = "Cost: ₹ " + costLabel[context[0].dataIndex];
                        return price;
                    },
                },
            },
        },
    };
    if (groupBy === 'toolName' &&
        options.plugins &&
        options.plugins.tooltip &&
        options.plugins.tooltip.callbacks) {
        options.plugins.tooltip.callbacks.footer = (context) => {
            let media = "Media: " + mediaLabel[context[0].dataIndex];
            return media;
        };
    }
    const pieChartData = {
        labels: chartLabels,
        datasets: [
            {
                data: percentage,
                backgroundColor: chartColors,
                spacing: 0,
                borderWidth: 0,
                textTransform: "capitalize",
            },
        ],
    };
    return (_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", sx: { padding: "32px 28px 70px 28px" } }, { children: [_jsx(Stack, Object.assign({ sx: { marginRight: "60px", width: "50%" } }, { children: _jsx(Chart, { type: "pie", data: pieChartData, options: options }) })), _jsx(Stack, Object.assign({ alignItems: "flex-start", spacing: 7, sx: { width: "50%" }, color: "text.light" }, { children: pieChartData === null || pieChartData === void 0 ? void 0 : pieChartData.labels.map((label, idx) => {
                    var _a;
                    const legendColor = (_a = pieChartData === null || pieChartData === void 0 ? void 0 : pieChartData.datasets[0]) === null || _a === void 0 ? void 0 : _a.backgroundColor[idx];
                    return _jsx(PieChartLegend, { label: label || "", legendColor: legendColor }, idx);
                }) }))] })));
}
PieChart.propTypes = {
    data: PropTypes.array,
    groupBy: PropTypes.string
};
export default PieChart;
